import style from "../../../assets/scss/sub/startGuide.module.scss";
import React from "react";
import {useLanguage} from "../../../hooks/hooks";

interface Args {
    img: string;
    idx: number;
    title: string;
    children: React.ReactNode;
    containerStyle?: string;
}

export function StartGuideOptions(
    {img, idx, title, children, containerStyle}: Args
) {
    const containerClassName = containerStyle ? style[containerStyle] || '' : '';
    const { isKorean } = useLanguage();

    const imageUrl = () => {
        //예시 https://images.feel-good.io/inspection_method/organ_info_01.png
        const defaultUrl = `https://images.feel-good.io/inspection_method/`;
        return defaultUrl + img + (isKorean ? "" : "_en") + ".png";
    }

    return (
        <div className={`${style.processTextContainer} ${containerClassName}`}>
            <img src={imageUrl()} className={style.processImg} alt={img}/>
            <div className={style.processStep}>
                <div className={`${style.processHeader} ${isKorean ? "" : style.en}`}>
                    <p className={style.stepNumber}>
                        <span className={style.firstLetter}>0</span>
                        <span>{idx}</span>
                    </p>
                    <p className={style.stepTitle}>{title}</p>
                </div>
                <div className={style.verticalBar}></div>
                <div className={style.ulContainer}>
                    {children}
                </div>
            </div>
        </div>
    )
}